import type { BomSummary } from '@ztechapps/product.common'
import React from 'react'
import { AdjustButtonProvider } from './Context'
import { Layout } from './Layout'

type AdjustmentButtonProps = BomSummary & {
  onAfterAction?: () => void
}

export const AdjustmentButton = ({ onAfterAction, ...props }: AdjustmentButtonProps) => {
  return (
    <AdjustButtonProvider {...props} onAfterAction={onAfterAction}>
      <Layout />
    </AdjustButtonProvider>
  )
}
